module.exports = "/fonts/gt-walsheim-medium.ttf";